import useEnsureAnchorExistingSystemOfType from 'hooks/use-ensure-anchor-existing-system-of-type';
import useIsDuctedPathway from 'hooks/use-is-ducted-pathway';
import useIsHybridPathway from 'hooks/use-is-hybrid-pathway';
import useIsPtacPathway from 'hooks/use-is-ptac-pathway';
import { anchorSystemTypeForPathway } from 'utils/anchor-existing-system';

export default function useEnsureAnchorExistingSystem() {
  const isDuctedPathway = useIsDuctedPathway();
  const isHybridPathway = useIsHybridPathway();
  const isPtacPathway = useIsPtacPathway();
  useEnsureAnchorExistingSystemOfType(
    anchorSystemTypeForPathway({
      isDuctedPathway,
      isHybridPathway,
      isPtacPathway
    })
  );
}
